export default __webpack_public_path__ + "static/media/FeverInTheOceans_01.f0135fab.png";